import { Grid, Typography } from "@mui/material";
import ResourceVStatus from "./ResourceVStatus";
import { SummaryCompleteProps } from "../../app/models/SummaryComplete";
import UploadDocumentsRSV from "./RSVUploadDocs";
import { useState, useEffect, useCallback } from "react";
import agent from "../../app/api/agent";
import LoadingSpinner from "../../app/common/LoadingSpinner";
import { useAppSelector } from "../../app/store/configureStore";
import CongratsPopUp from "../../app/common/CongratsPopUp";

export default function CompetencyVResourceCollection() {
  const { user } = useAppSelector((state) => state.account);
  const [isLoading, setIsLoading] = useState(true);

  const description =
    user && user?.credentialTypeId === 4 ? (
      <Typography component="span">
        <ul>
          Provide three examples of record-keeping forms you use/have used:
          <ol>1. Family Members and Ages:</ol>
          <ol>2. Family (Adult) Strengths:</ol>
          <ol>
            3. Family Needs/Challenges: (physical, emotional, developmental,
            social, educational)
          </ol>
        </ul>
      </Typography>
    ) : (
      <Typography component="span">
        <ul>
          Provide three examples of record-keeping forms you use/have used:
          <ol>1. An accident report form</ol>
          <ol>2. An emergency form</ol>
          <ol>
            3. A completed observation form (a form that you have used to
            observe and document a child's developmental/learning
            progress&mdash;without the child's name)
          </ol>
        </ul>
      </Typography>
    );

  const [summaryCompleteProps, setSummaryCompleteProps] =
    useState<SummaryCompleteProps>({
      title: "My Resource Collection V",
      percent: "",
      header:
        "Competency V: To ensure a well-run, purposeful program that is responsive to participant needs",
      description: description,
    });

  const [userProgress, setUserProgress] = useState(0);
  const [popUp, setPopUp] = useState(false);
  const handlePopUp = () => {
    setPopUp(false);
  };

  const fetchData = useCallback(async () => {
    try {
      if (user?.credentialName && user?.portfolioId) {
        const compData = await agent.Progress.GetCompentencyResultsByType(
          user.portfolioId,
          "RCV"
        );

        setUserProgress(compData.resourceProgress);
        setSummaryCompleteProps((prevSummaryCompleteProps) => ({
          ...prevSummaryCompleteProps,
          percent: compData.resourceProgress + "%",
        }));

        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }, [user?.credentialName, user?.portfolioId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const RecallData = () => {
    fetchData();
  };

  const handleSave = async () => {
    console.log("handleSave");
    setIsLoading(true);
    fetchData();
    setIsLoading(false);
    if (userProgress >= 100) {
      setPopUp(true);
    }
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Grid container p={2} mb={2}>
      <ResourceVStatus {...summaryCompleteProps} />
      <UploadDocumentsRSV
        onSave={handleSave}
        userProgress={userProgress}
        RecallData={RecallData}
      />
      <CongratsPopUp
        handlePopUp={handlePopUp}
        isPopUp={popUp}
        btnColor={"compV"}
        background={"compV.light"}
        description={
          "You have completed the Resource Collection for Competency V."
        }
      />
    </Grid>
  );
}
